import _slicedToArray from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
/**
 * Parse ACR validation error messages from pipe-delimited format
 * Example: "L3012:Warning. Date_Of_Birth is required|L3012:Warning. Patient_Sex is required"
 */
export function parseValidationErrors(validationErrors) {
  var _validationErrors$Exa;
  if (!(validationErrors !== null && validationErrors !== void 0 && (_validationErrors$Exa = validationErrors.Exam_Errors) !== null && _validationErrors$Exa !== void 0 && _validationErrors$Exa.length)) {
    return [];
  }
  var errors = [];
  validationErrors.Exam_Errors.forEach(function (examError) {
    if (!examError.Error_Msg) return;

    // Split by pipe to get individual errors
    var errorMessages = examError.Error_Msg.split("|");
    errorMessages.forEach(function (msg) {
      var trimmed = msg.trim();
      if (!trimmed) return;

      // Parse format: "L3012:Warning. Field_Name is required..." or "L3012:Warning Field_Name..."
      var match = trimmed.match(/^(L\d+):(Warning|Invalid|Error)\.?\s*(.+)/);
      if (match) {
        var _match = _slicedToArray(match, 4),
          code = _match[1],
          type = _match[2],
          message = _match[3];

        // Extract field name from message (usually the first word or before "is")
        var fieldMatch = message.match(/^([A-Za-z_]+)/);
        var fieldName = fieldMatch ? fieldMatch[1] : "";
        errors.push({
          code: code,
          type: type,
          fieldName: fieldName,
          message: message.trim(),
          fullMessage: trimmed
        });
      } else {
        // Fallback for messages that don't match the pattern
        errors.push({
          code: "",
          type: "Error",
          fieldName: "",
          message: trimmed,
          fullMessage: trimmed
        });
      }
    });
  });
  return errors;
}

/**
 * Group errors by field name
 */
export function groupErrorsByField(errors) {
  var grouped = {};
  errors.forEach(function (error) {
    var key = error.fieldName || "_general";
    if (!grouped[key]) {
      grouped[key] = [];
    }
    grouped[key].push(error);
  });
  return grouped;
}

/**
 * Get human-readable field name from snake_case
 */
export function formatFieldName(fieldName) {
  return fieldName.split("_").map(function (word) {
    return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
  }).join(" ");
}